import Vue from "vue";

export default container => {
    container.declare("features", ({detector}) => {
        const features = Vue.observable({...detector.features});
        // handler of changes in features
        const onFeatureChange = (name, value) => {
            Vue.set(features, name, value);
        };
        // add listener on detector
        detector.subscribe(onFeatureChange);
        return {features};
    });
};
